<template>
    <div>
        <h1 class="text-left">{{ $t('bitmapTypeButtonTitle') }}</h1>
        <span class="badge badge-primary" v-show="loading">{{
            $t('loading')
        }}</span>
        <!-- Overview Table -->
        <div class="max-row-scroll">
            <b-table
                id="bitmapsoverview"
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoaded"
                @row-clicked="$_onSelect"
                :sort-by.sync="sortBy"
                :tbody-tr-class="$_rowClass"
                :items="bitmapTypeButton"
                :fields="fields"
                sort-icon-left
            >
                <template v-slot:cell(imageData)="data">
                    <b-form-checkbox
                        v-bind:id="`${data.item.id}_ckbox`"
                        v-bind:name="`${data.item.id}_ckbox`"
                        v-model="data.item.selected"
                        @change="$_onChecked($event, data.item)"
                    >
                        <b-img
                            :src="data.item.imageData"
                            fluid
                            alt="Responsive image"
                        ></b-img>
                    </b-form-checkbox>
                </template>
            </b-table>
        </div>
        <!-- No content for overview -->
        <div v-if="noImagePresent" class="col-md-12">
            <span> &nbsp; {{ $t('noImagesPresent') }}</span>
        </div>
        <div v-show="dataLoaded" class="btn-group">
            <b-button
                id="add_button"
                @click="$_onSave"
                variant="primary"
                class="d-flex align-items-center"
            >
                {{ $t('btnSelectLabel') }}
            </b-button>
            <b-button
                id="add_bitmap_button"
                @click="$_onAdd"
                class="d-flex align-items-center btn-space-5"
            >
                {{ $t('btnAddLabel') }}
            </b-button>
            <b-button
                id="cancel_add_button"
                @click="$_onCancel"
                class="d-flex align-items-center btn-space-5"
            >
                {{ $t('btnCancelLabel') }}&nbsp;<span
                    class="fas fa-times"
                ></span>
            </b-button>
        </div>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import { arrayNotEmpty } from '../../services/utilities';

    export default {
        name: 'bitmaps-select-overview',

        mixins: [modalMixin],

        props: { displayedInModal: { type: Boolean, default: false } },

        data() {
            return {
                selectedBitmap: null,
                bitmapTypeButton: [],
                loading: false,
                noImagePresent: false,
                fields: [
                    {
                        key: 'imageData',
                        label: 'Afbeelding',
                        sortable: false,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        stickyColumn: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    }
                ],
                sortBy: 'name'
            };
        },

        computed: {
            dataLoaded() {
                return arrayNotEmpty(this.bitmapTypeButton);
            }
        },

        created() {
            this.$_getOrganizationImages();
        },

        methods: {
            /*
             * Converts image data from base64 to string representation
             */
            $_convertImageData() {
                if (arrayNotEmpty(this.bitmapTypeButton)) {
                    this.bitmapTypeButton.forEach((image) => {
                        image.imageData = Buffer.from(
                            image.imageData,
                            'base64'
                        ).toString();
                        image.name = image.name || this.$t('noFilenameDefined');
                    });
                }
            },

            /*
             * Gets all defined bitmaps for organization
             */
            async $_getOrganizationImages() {
                this.loading = true;
                await this.$store.dispatch('useApiData', {
                    name: 'GetUrlConnectionBitmaps'
                })
                    .then((result) => {
                        if (result.data && result.data.length > 0) {
                            result.data.forEach((item) => {
                                item.selected = false;
                            });
                        }
                        this.bitmapTypeButton = Object.assign([], result.data);
                        this.$_convertImageData();
                        this.noImagePresent = this.bitmapTypeButton.length === 0;
                        this.loading = false;
                    })
                    .catch((error) => {
                        const data = {
                            message: error.message,
                            variant: 'danger',
                            title: this.$t('imageGetFailedError'),
                            autoHideDelay: 5000
                        };
                        this.loading = false;
                        this.showToast(data);
                    });
            },

            /*
             * Returns the selected bitmap object
             */
            $_getSelectedBitmap() {
                return this.bitmapTypeButton.find((item) => item.selected === true);
            },

            $_onAdd() {
                this.$emit('select-bitmap-add');
            },

            $_onCancel() {
                this.$emit('select-bitmap-cancel');
            },

            /*
             * Sends the selected bitmap to caller
             */
            $_onSave() {
                this.selectedBitmap = this.$_getSelectedBitmap();
                if (this.selectedBitmap) {
                    this.$emit('select-bitmap-saved', this.selectedBitmap);
                } else {
                    this.showToast({
                        message: this.$t('errorMissingBitmap'),
                        variant: 'danger',
                        title: this.$t('noImagesSelected'),
                        autoHideDelay: 3000
                    });
                }
            },

            /**
             * Sets the selected property of input item to checked status
             * @param checked
             * @param input
             */
            $_onChecked(checked, input) {
                this.bitmapTypeButton.forEach((item) => {
                    item.selected = false;
                });
                input.selected = checked;
            },

            /**
             * Sets selected state of input element
             * @param input
             */
            $_onSelect(input) {
                this.bitmapTypeButton.forEach((item) => {
                    item.selected = item.id === input.id;
                });
            },

            /*
             * Sets the class of a row
             */
            $_rowClass() {
                return 'tablerow';
            }
        }
    };
</script>

<style scoped>
.img-fluid {
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    padding: 5px !important;
    max-width: 100px !important;
    height: 35px !important;
}

.max-row-scroll {
    max-height: 300px;
    overflow-y: auto;
}
</style>
